<template>
  <div>
    <header>
      <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">Manufacturing Multi-Organs (MM)</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <!-- Sidebar Toggle-->
          <button class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" id="sidebarToggle" @click="sidebarToggle"><i class="fas fa-bars"></i></button>
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav me-auto mb-2 mb-auto">
              <li class="nav-item">
                <a class="nav-link" aria-current="page" @click="routePush('/')">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/organs')">Organs</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/models')">Models</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" @click="routePush('/materials')">Materials</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://gulab.info/about/">About</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/visitors')">Visitors</a>
              </li>
            </ul>
            <form class="d-flex">
              <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
              <button class="btn btn-outline-light" onmouseover="this.style.backgroundColor='black';" onmouseout="this.style.backgroundColor='';"
                      type="submit" style="color:white">Search</button>
            </form>
          </div>
        </div>
      </nav>
    </header>

    <div class="sb-nav-fixed">

      <div id="layoutSidenav">
        <div id="layoutSidenav_nav" style="z-index: 3">
          <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
            <div class="sb-sidenav-menu">
              <div class="nav">
                <div class="sb-sidenav-menu-heading">Statistics</div>
                <a class="nav-link" @click="routePush('/materials')">
                  <div class="sb-nav-link-icon"><i class="fas fa-chart-pie"></i></div>
                  Components
                </a>
                <a class="nav-link active collapsed" @click="routePush('/patents')" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                  <div class="sb-nav-link-icon"><i class="fas fa-chart-area"></i></div>
                  Patents
                </a>
                <a class="nav-link collapsed" @click="routePush('/pantentComponents')" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                  <div class="sb-nav-link-icon"><i class="fas fa-chart-bar"></i></div>
                  Pantent Components
                </a>
              </div>
            </div>

          </nav>
        </div>
        <div id="layoutSidenav_content" style="margin-top:3%">
          <main>
            <div class="container-fluid px-4">

              <form class="row g-3 needs-validation" novalidate onsubmit="return false" style="margin: 0">
                <div class="col-6">
                  <label class="form-label"><strong><span style="color:darkblue">Biomaterials:</span></strong></label>
                  <el-select v-model="valueType" placeholder="Choose..." size="small" @change="handleSecTopicType()" style="width: calc(100% - 110px)">
                    <el-option
                      v-for="item in optionsType"
                      :key="item.type"
                      :label="item.type"
                      :value="item.type">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-6">
                  <el-select v-model="value" placeholder="Choose..." size="small" @change="handleSecTopic()" style="width: 100%">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.biomaterial"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </form>
              <div class="row" style="margin-top: 20px;clear: both">
                <div class="col-xl-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-pie me-1"></i>
                      Statistic of country
                    </div>
                    <div class="card-body"><div id="country" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of institute
                    </div>
                    <div class="card-body"><div id="institute" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xl-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-bar-chart me-1"></i>
                      Statistic of claims
                    </div>
                    <div class="card-body"><div id="claims" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of grants
                    </div>
                    <div class="card-body"><div id="grants" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-header">
                  <i class="fas fa-table me-1"></i>
                  Related Patents
                </div>
                <div class="card-body">
                  <el-table
                    :data="tableData"
                    stripe
                    :border="false"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    style="width: 100%">
                    <el-table-column
                      prop="title"
                      sortable
                      label="Title">
                    </el-table-column>
                    <el-table-column
                      prop="application_date"
                      sortable
                      align="center"
                      label="Application Date">
                    </el-table-column>
                    <el-table-column
                      prop="open_no"
                      sortable
                      align="center"
                      label="Publication Number">
                    </el-table-column>
                    <el-table-column
                      prop="authorization_announcement_date"
                      sortable
                      align="center"
                      label="Authorization Date">
                    </el-table-column>
                  </el-table>

                  <div style="text-align: end;position: relative;margin-top: 20px">
                    <el-pagination
                      background
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="limit"
                      layout="prev, pager, next, jumper"
                      :total="total">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <footer class="py-4 bg-light mt-auto">
            <div class="container-fluid px-4">
              <div class="d-flex align-items-center justify-content-between small">
                <div class="text-muted">Copyright &copy; Group of Bioinspired Engineering 2023</div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import '../../assets/js/jquery-3.6.0.min.js'
// import '../../assets/js/bootstrap.bundle.min.js'
import * as echarts from "echarts";

import {
  getBiomaterialList,
  getPatentCountry,
  getPatentInstituteList,
  getPatentClaims,
  getPatentGrants,
  getRelatedPatent

} from "@/request/materials";
export default {
  name: 'index',
  data(){
    return{
      tableData: [],
      limit: 10,
      currentPage: 1,
      total: 0,
      value: '',
      valueType: 'Synthetic',
      optionsType: [],
      options: [],

    }
  },
  mounted () {
    this.getBiomaterial();
  },
  methods:{
    getBiomaterial(){
      getBiomaterialList('').then(res => {
        this.optionsType= res;
        let newArr= res.filter((item)=>{
            return this.valueType===item.type;
        });
        this.options= newArr[0].child;
        this.value= 'a88ca80486e19685b17923e03b3bedb8';
        this.getPatentCountry();
        this.getPatentInstituteList();
        this.getPatentClaims();
        this.getPatentGrants();
        this.getRelatedPatent();
      });
    },

    getPatentCountry(){
      let param={ biomaterial: this.value };

      getPatentCountry(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.country;
          item.value= item.count;
          if (inx<=9)
            return item;
        });

        let seriesData=  data;
        let ctx = echarts.init(document.getElementById('country'));
        let option  = {
          color: [
            '#6AA0FF',
            // '#0077FC',
            // '#3B53AD',
            '#10C2D1',
            // '#00ED9C',
            '#FFC833',
            '#FFAC22',
            '#FBDC80',
            '#2738A2',
            '#10C2D1',
            '#0044F4',
            '#0095FD',
            '#00B3FF',
            '#00E1F4',
            '#00ED9C',
            '#00FF9F',
            '#FFC833',
            '#FFAC22',
            '#FBDC80',
            '#FFD600',
            '#4F80FF',
            '#D9E7FF',
            '#3E60C8',
          ],
          tooltip: {
            trigger: 'item'
          },
          legend: {
            // top: '5%',
            // left: 'center'
            orient: 'vertical',
            right: 'right',
            // bottom: 0
            // selectedMode:false
            backgroundColor: 'white',
            formatter: function (name) {
              return name.length > 10 ? name.slice(0, 10) + '...' : name;
            }
          },
          series: [
            {
              type: 'pie',
              avoidLabelOverlap: false,
              // roseType: 'area',
              // radius: [20, '80%'],
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: true,
                formatter: '{b}: {@2012} ({d}%)'
              },
              labelLine: {
                show: true
              },
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    getPatentInstituteList(){
      let param={ biomaterial: this.value};
      getPatentInstituteList(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.organization;
          item.value= item.count;
          if (inx<=9)
            return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#01ec9db3' },
              { offset: 0.2, color: '#01ec9db3' },
              { offset: 1, color: '#01ec9d' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData= data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('institute'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data: xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });

    },

    getPatentClaims(){
      let param={ biomaterial: this.value};
      getPatentClaims(param).then(res => {
        const data= res.filter((item,inx)=>{
          // item.name= item.name;
          item.value= item.count;
          if (inx<=9)
            return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [10, 10, 0, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#788de0b3' },
              { offset: 0.2, color: '#788de0b3' },
              { offset: 1, color: '#788de0' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'top',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData= data;
        let ctx = echarts.init(document.getElementById('claims'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            right : 0,
            bottom : 0,
            top : 20,
            containLabel : true
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data: xAxisData.splice(0,100)
            }
          ],
          yAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });

    },

    getPatentGrants(){
      let param={ biomaterial: this.value };

      getPatentGrants(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.year;
          item.value= item['patent_count'];
          if (inx<=9)
            return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#51d8e7' },
              { offset: 0.2, color: '#2cbccc' },
              { offset: 1, color: '#16a5b4' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData=  data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('grants'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data:  xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    getRelatedPatent(){
      let parameter = { page:this.currentPage, biomaterial: this.value };
      getRelatedPatent(parameter).then(res => {
        this.tableData= [];
        this.tableData= res;
        this.total= res.length;
      });
    },

    handleSecTopicType(){
      let newArr= this.optionsType.filter((item)=>{
        return this.valueType===item.type;
      });
      this.options= newArr[0].child;
      this.value= '';

    },

    handleSecTopic(){
      this.getPatentCountry();
      this.getPatentInstituteList();
      this.getPatentClaims();
      this.getPatentGrants();
      this.getRelatedPatent();
    },

    handleCurrentChange(val) {
      this.currentPage= val;
      this.getRelatedPatent();
    },

    sidebarToggle(){
      document.body.classList.toggle('sb-sidenav-toggled');
      localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
    },

    routePush(path){
      this.$router.push({ path:path })
    },
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/styles.css";
@import "../../assets/css/bootstrap.min.css";

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/materials/patents.vue